import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import successIcon from 'assets/img/icons/success-green-big.svg'
import iconFail from 'assets/img/icons/icon-warning.svg'
import craftPredictionIcon from 'assets/img/icons/welcome-220k.svg'
import { CraftPredictionContext } from "pages/CraftPrediction";
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton';
import { useSoundPath } from 'hooks/useSoundPath';
import ModalWindow from 'components/ModalWindow';

const CraftingPredictionPopup = ({ setIsCraft, submitHandler, craftingStep, setCraftingStep, isCraftLoading, errorText }) => {

  const navigate = useNavigate();
  const [isCloseDisabled, setIsCloseDisabled] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const playSound = useSoundPath();

  const { clearBlocks } = useContext(CraftPredictionContext);

  const closeWindow = () => {
    playSound('main');
    if (craftingStep === 'success') {
      clearBlocks();
    }
    setCraftingStep('submit');
    setIsCraft(false);
  }

    useEffect(() => {
    const observer = new MutationObserver(() => {
      const element = document.querySelector('.uf-visible');
      setIsCloseDisabled(!!element);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <ModalWindow  close={closeWindow}>
      <div className={`modal-window__wrapper ${craftingStep === 'success' ? 'modal-window__wrapper--success' : ''}`} onClick={(e) => e.stopPropagation()}>
        <PagePopopCloseButton close={closeWindow} />
        {
          craftingStep === 'submit' ? <>
            <header className="modal-window__header">
              <img src={craftPredictionIcon} className="modal-window__icon" alt="" />
              <h5 className="modal-window__title">Craft Prediction</h5>
              <p className="modal-window__info">
                Your cards will be placed inside the Prediction Card. If the prediction resolves true, the Prize Card becomes redeemable.
                If it resolves false the Prize card is burned.
              </p>
              <p className="modal-window__info">The Identity Card is returned to you whether the prediction resolves true or false.</p>
            </header>
            <p className="crafting-popup__form-terms">
              <input type="checkbox" defaultChecked={isTermsAccepted} value="accept terms of crafting" id="crafting-terms" required />
              <label htmlFor="crafting-terms" onClick={() => setIsTermsAccepted(!isTermsAccepted)}>
                I acknowledge the Event, Trigger, Prize and Prediction cards may be burned and not returned to me.
              </label>
            </p>
            <footer className="modal-window__footer">
              <button
                className="modal-window__footer-close"
                onClick={() => setIsCraft(false)}
                disabled={isCloseDisabled}
              >
                Cancel
              </button>
              <button className={`modal-window__footer-submit ${isCraftLoading ? 'loading' : ''}`}
                disabled={!isTermsAccepted || isCraftLoading}
                type='submit'
                onClick={(e) => {
                  submitHandler(e)
                }}>Craft</button>
            </footer>
          </>
            : null
        }
        {
          craftingStep === 'success' ? <>
            <header className="modal-window__header">
              <img src={successIcon} className="modal-window__icon" alt="" />
              <h5 className="modal-window__title">Success!</h5>
              <p className="modal-window__info">Your transaction was completed.</p>
            </header>
            <footer className="modal-window__footer">
              <button
                className="modal-window__footer-close"
                onClick={closeWindow}
              >
                Done
              </button>
              <button className="modal-window__footer-submit" onClick={() => {
                navigate('/inventory/predictions');
                playSound('main');
              }}>View Predictions</button>
            </footer>
          </>
            : null
        }

        {
          craftingStep === 'fail' && (
            <>
            <header className="modal-window__header">
              <img src={iconFail} className="modal-window__icon" alt="" />
              <h5 className="modal-window__title">Craft prediction failed.</h5>
              <p className="modal-window__info">{errorText}</p>
            </header>
            <footer className="modal-window__footer">
              <button className="modal-window__footer-close" onClick={closeWindow}>Got it</button>
            </footer>
            </>
          )
        }

        {
          craftingStep === 'rejected' && (
            <>
            <header className="modal-window__header">
              <img src={iconFail} className="modal-window__icon" alt="" />
              <h5 className="modal-window__title">Unable to craft prediction!</h5>
              <p className="modal-window__info">It’s too close to the start of this event to make a prediction</p>
            </header>
            <footer className="modal-window__footer">
              <button className="modal-window__footer-close" onClick={closeWindow}>Got it</button>
            </footer>
            </>
          )
        }
      </div>
    </ModalWindow>
  )
}

export default CraftingPredictionPopup;
